import React from 'react';
import SvgIcon, { icons } from '../SvgIcon';

const MapIcons = () => {
    const arr = Object.keys(icons);
    return arr.map(typeID => (<div className="sports-icons__item" key={typeID}><SvgIcon typeID={typeID} /></div>));
};

const SectionSportsIcons = () => (
    <section className="section bg-l-blue section__icon_head">
        <div className="section__wrapper">
            <div className="sports-icons">
                <div className="sports-icons__container">
                    <div className="sports-icons__content">
                        <MapIcons />
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default SectionSportsIcons;



// WEBPACK FOOTER //
// ./src/components/SectionSportsIcons/index.jsx